import React from "react";

import AllPagesPDFViewer from "./partial/AllPages";
import cv from "./files/cv.pdf";

function CV() {
  return (
    <React.Fragment>
      <div style={cvStyle}>
        <AllPagesPDFViewer pdf={cv} />
      </div>
    </React.Fragment>
  );
}

const cvStyle = {
  height: "200px",
  width: "940px",
  margin: "auto",
  padding: "10px 10px 10px 10px",
  backgroundColor: "#fff",
};

export default CV;
